const SubjectAreaModule = () => {
  const toggleSubjectAreaLinksButtons =
    document.querySelectorAll<HTMLButtonElement>(
      ".show-more__subject-area-links",
    );

  const toggle = (e: Event) => {
    const target = e.currentTarget as HTMLButtonElement;

    // Find the closest container
    const container = target.closest(".subject-area__body");
    if (!container) return;

    const subjectAreaLinks = container.querySelectorAll(".subject-area-link");

    const isHidden = Array.from(subjectAreaLinks).some((link) =>
      link.classList.contains("h-hidden"),
    );

    subjectAreaLinks.forEach((link) => {
      if (isHidden) {
        link.classList.remove("h-hidden");
        link.setAttribute("aria-hidden", "false");
        target.innerText = "Visa färre -";
      } else {
        link.classList.add("h-hidden");
        link.setAttribute("aria-hidden", "true");
        target.innerText = "Visa alla +";
      }
    });
  };

  const init = () => {
    toggleSubjectAreaLinksButtons.forEach((button) => {
      button.addEventListener("click", toggle);
    });
  };

  return {
    init,
  };
};

export { SubjectAreaModule };
